

















import { Component, Vue, Prop } from 'nuxt-property-decorator';

@Component
export default class ShowsFilter extends Vue {
  @Prop(Boolean)
  open!: boolean

  @Prop({ type: String, required: true })
  labelledBy!: boolean
}
